import React, { useState, useEffect } from "react";
import PaginationComponent from "../../../components/PaginationComponent";
import useTagHistory from "../../../utils/CustomHooks/useTagHistory";
import { sortArray } from "../../../utils/Functions/filter";
import QuestionTableItem from "../components/QuestionTableItem";

export default function TagHistoryTable({ id = "" }) {
  const { tagHistory, loading, getTagHistory } = useTagHistory("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const pageCount = Math.ceil(tagHistory.length / pageSize);

  useEffect(() => {
    if (id) getTagHistory(id);
  }, [id]);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };

  return (
    <>
      <table className="table table-borderless ">
        <thead>
          <tr className=" ">
            <td className="">Action</td>
            <td className="">Time </td>
            <td className="">By</td>
          </tr>
        </thead>
        <tbody>
          {tagHistory.length > 0 ? (
            sortArray(tagHistory)
              .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
              .map((x, i) => <QuestionTableItem data={x} key={i} />)
          ) : (
            <tr>
              <td className="text-center font-weight-bold" colSpan="7">
                {loading ? "loading..." : "No Hisory Found..."}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {tagHistory.length > 0 && (
        <PaginationComponent
          handleClick={handleClick}
          currentPage={currentPage}
          pageCount={pageCount}
        />
      )}
    </>
  );
}
